import EffectAmount from '@/roc/effects/EffectAmount';

class CultureRange extends EffectAmount
{
}

export default CultureRange;
